import { useLanguage } from '../../../context/LanguageContext';

export default function About() {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-center">
          <div className="lg:col-span-3">
            <div className="inline-block px-6 py-2 bg-[#1A2B4A]/10 text-[#1A2B4A] rounded-full text-sm font-medium mb-10">
              {t('about.badge')}
            </div>
            <h2 className="text-5xl font-serif font-bold text-[#1A2B4A] leading-tight mb-8">
              {t('about.heading')}
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              {t('about.paragraph')}
            </p>
          </div>

          <div className="lg:col-span-2 relative">
            <div className="absolute -top-4 -right-4 w-20 h-1 bg-[#C9A961]"></div>
            <div className="w-full h-96 rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/893ef31805284692b359a5c01ce66feb.jpg"
                alt="International Business Meeting"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}